// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_1KzOA","cdpWrapper":"_35cY0","wrapper":"_12l8I","containerSectionWrapper":"VhQWI","containerWrapper":"_3bH08","revampSectionWrapper":"_3I1tc"};